<app-popover-editor-url 
  (atualizarParentEventEmitter)="atualizarParentEventEmitter()"
  #popoverEditorUrl>
</app-popover-editor-url>

<div class="ui-g">
  <div class="ui-g-12 autenticacao-container">
    <div class="card card-stats">
      <div class="card-header texto-cinza titulo">
        <label class="card-label-header">Configuração de segurança</label>
      </div>

      <div class="card-content">
        <p>
          <label class="category titulo-label-de-ajuda">Algoritmo:</label>
          <label>AES/CBC/PKCS5Padding</label>
        </p>
        <p>
          <label class="category titulo-label-de-ajuda">Chave:</label>
          <input 
            [disabled]="true"
            type="{{chaveCriptografiaInputType}}"
            name="chaveCriptografia" 
            [(ngModel)]="chaveCriptografia"
            pInputText>
          <label class="texto-cinza"></label>
        </p>

        <p class="texto-ajuda texto-marrom">
          <label *ngIf="chaveCriptografia">Para desligar a criptografia, solicite a remoção da chave de segurança para o administrador do sistema.</label>
          <label *ngIf="!chaveCriptografia">Para ligar a criptografia, solicite o cadastro da chave de segurança para o administrador do sistema.</label>
        </p>
      </div>

      <div class="card-footer footer" *ngIf="chaveCriptografia">
        <div class="stats">
          <a class="span-link-acao" href="javascript:void(0);" (click)="fnExibirChaveCriptografia()">Ver chave</a>
          <!-- <a class="span-link-acao" href="javascript:void(0);" (click)="apagarChaveCriptografia()">Apagar chave</a>
          <a class="span-link-acao" href="javascript:void(0);" (click)="gerarNovaChaveCriptografia()">Gerar nova chave</a> -->
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 container">
    <p-tree 
      [style]="{'width':'100%'}"
      [value]="arvore" 
      layout="vertical">
    
      <ng-template let-evento  pTemplate="cfg-integracao-evento">
        <app-cfg-integracao-evento [cfgIntegracaoEvento]="evento"></app-cfg-integracao-evento>
      </ng-template>
    
    </p-tree>
  </div>
</div>

